import { createPubSub } from '@/helpers/pubSub';

export const menuTreeEventBus = createPubSub();

// events
export const ON_ITEM_SELECT = 'ITEM_SELECT';
